import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Checkbox, Button, Modal, List, Table } from "antd";

import Content from "../../commons/components/content";
import Pagination from '../../commons/components/pagination';
import Input from "../../commons/components/input";
import SearchInput from "../../commons/components/searchInput";
import Loading from "../../commons/components/loading";
import ButtonIcon from "../../commons/components/buttonIcon";

import ServicePartner from '../../services/partners';

export default () => {

    const [totalPages, setTotalPages] = useState(1);
    const [actualPage, setActualPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loadingTable, setLoadingTable] = useState(true);
    const [loadingApplications, setLoadingApplications] = useState(true);

    const [partner, setPartner] = useState({})
    const [selectedPartner, setSelectedPartner] = useState({})
    const [applications, setApplications] = useState([]);
    const [showModalViewPartner, setShowModalViewPartner] = useState(false);
    const [showModalApplications, setShowModalApplications] = useState(false);

    const tableColumns = [
        {
            title: 'Codigo',
            dataIndex: 'codparc',
            key: 'codparc',
        },
        {
            title: 'Parceiro',
            dataIndex: 'company_name',
            key: 'company_name',
        },
        {
            title: 'CNPJ',
            dataIndex: 'identification_number',
            key: 'identification_number',
        },
        {
            title: 'SAS',
            dataIndex: 'sas',
            key: 'sas',
        },
        {
            title: 'Ativo',
            dataIndex: 'active',
            key: 'active',
        },
        {
            title: 'Ação',
            key: 'action',
            render: (text, partner) => (
                <div style={{ display: 'flex' }}>
                    <ButtonIcon className="button-edit" text="Listar Aplicações" type="book" callback={() => handleApplicationsPartner(partner)} />
                    <ButtonIcon className="button-edit" text="Visualizar Parceiro" type="eye" callback={() => handleModalViewPartner(partner)} />
                </div>
            ),
        },
    ];

    const [tableData, setTableData] = useState([])

    useEffect(() => {
        if (search === "") {
            getPartners()
        }
    }, [search]);

    async function getPartners(page = 1) {
        setLoadingTable(true);
        let response = await ServicePartner.getAll(page)
        if (response) {
            formatTable(response.data.data)
            setActualPage(page);
            setTotalPages(response.data.pagination)            
            setLoadingTable(false);
        }
        setShowModalViewPartner(false)
    }

    async function getPartner(id) {
        setLoadingTable(true);
        let response = await ServicePartner.getId(id)
        if (response) {
            setPartner(response.data.data[0]);
            setLoadingTable(false);
        }
    }

    async function searchPartner(search) {
        setLoadingTable(true);
        let response = await ServicePartner.search(search)
        if (response) {
            formatTable(response.data.data)
            setActualPage(search);
            setTotalPages(response.data.pagination)            
            setLoadingTable(false);
        }
    }

    async function getApplications(id_partner) {
        setLoadingApplications(true);

        let response = await ServicePartner.getApplications(id_partner)
        if (response) {
            const data = response.data.data;
            let array = [];
            data.forEach((application) => {
                array.push(application.application)
            })
            setApplications(array);            
        }

        setLoadingApplications(false);
    }

    function formatTable(data) {
        let array = [];
        data.forEach((partner) => {
            partner.key = partner.id;
            partner.active = partner.active === true ? "Sim" : "Não";
            array.push(partner)
        })
        setTableData(array);
    }

    function getPartnersOrSearch(page) {
        if (search === "") {
            getPartners(page)
        } else {
            searchPartner(search, page)
        }
    }

    function handleSearch(e) {
        setSearch(e.target.value);
        if (search.length > 2) {
            searchPartner(search);
        }
    }
    function handleApplicationsPartner(partner) {
        setSelectedPartner(partner);
        getApplications(partner.id);
        setShowModalApplications(true);
    }

    function handleModalViewPartner(partner) {
        getPartner(partner.id);
        setShowModalViewPartner(true);
    }

    function handleCancelModalViewPartner() {
        setPartner({})
        setShowModalViewPartner(false)
    }

    function handleCalcelModalApplications() {
        setSelectedPartner({})
        setShowModalApplications(false)
    }

    const applicationsModal = () => {
        function renderApplication() {
            return (
                <>
                    <List
                        size="small"
                        bordered
                        dataSource={applications}
                        renderItem={item => <List.Item>{item}</List.Item>}
                    />
                </>
            );
        }

        function renderApplications() {
            if (loadingApplications) {
                return (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                        <Loading width={50} height={50} />
                    </div>
                )
            } else {
                return (
                    <>
                        {renderApplication()}
                    </>
                );
            }
        }

        return (
            <Modal
                title={`Aplicações de ${selectedPartner.company_name}`} visible={showModalApplications} onCancel={handleCalcelModalApplications}
                footer={[
                    <button key="calcel" onClick={handleCalcelModalApplications} className="btn btn-primary">Fechar</button>
                ]}>
                {renderApplications()}
            </Modal>
        )
    }

    const modalViewPartner = () => (
        <Modal
            title="Dados do Parceiro" visible={showModalViewPartner} onCancel={handleCancelModalViewPartner}
            footer={[
                <button key="calcel" onClick={handleCancelModalViewPartner} className="btn btn-primary">Fechar</button>
            ]}>

            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Input readOnly
                            name="companyName" label="Razão Social" value={partner.company_name} />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <Input readOnly
                            name="tradingName" label="Nome Fantasia" value={partner.trading_name} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Input readOnly
                            name="sas" label="Sas" value={partner.sas} />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <Input readOnly
                            name="identificationNumber" label="CNPJ" value={partner.identification_number} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox readOnly inputId="cb_matriz" checked={partner.main_office} />
                        <label htmlFor="cb_ativo" className="p-checkbox-label" style={{ marginLeft: '5px' }}>Matriz</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <Checkbox readOnly inputId="cb_ativo" checked={partner.active} />
                        <label htmlFor="cb_ativo" className="p-checkbox-label" style={{ marginLeft: '5px' }}>Ativo</label>
                    </div>
                </div>
            </div>
        </Modal>
    );

    const renderSearchApplication = () => (
        <div style={{ marginBottom: 10 }}>
            <SearchInput
                placeholder="Pesquisar..."
                onChange={handleSearch}
                value={search}
                buttonLabel="Limpar" type="close" callback={() => setSearch("")} />
        </div>
    );

    const renderLoading = () => {
        if (loadingTable) {
            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Loading width={50} height={50} />
                </div>
            )
        }
    };

    const renderTable = () => (
        <Fragment>
            <Col span={24}>
                <div style={{ marginBottom: 20 }}>
                    <Table pagination={false} columns={tableColumns} dataSource={tableData} />
                </div>
            </Col>
        </Fragment>
    );

    const renderHeader = () => (
        <Fragment>
            <Col span={8}>
                {renderSearchApplication()}
            </Col>
            <Col span={10}>
                {renderLoading()}
            </Col>
        </Fragment>
    );

    return (
        <>
            <Content breadcrumb={["Parceiros"]} minHeight={360}>
                {modalViewPartner()}
                {applicationsModal()}

                <Row type="flex" align="middle">
                    {renderHeader()}
                </Row>

                <Row>
                    {renderTable()}
                </Row>

                <Row type="flex" align="middle">
                    <Col span={12}>
                        <Pagination totalPages={totalPages} actualPage={actualPage} callBack={(page) => getPartnersOrSearch(page)} />
                    </Col>
                </Row>
            </Content>
        </>
    )
}